var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:[
      _vm.themes[_vm.theme],
      _vm.sizes[_vm.size],
      {
        'btn--design-new': _vm.design === 'new',
        'btn--beauty': _vm.disabled,
        'btn--preload': _vm.preload
      }
    ],attrs:{"disabled":_vm.disabled,"type":_vm.type}},[(!_vm.preload)?_vm._t("default"):_vm._e(),(_vm.preload && _vm.design === 'new')?_c('span',{staticStyle:{"visibility":"hidden"},attrs:{"aria-hidden":"true"}},[_vm._t("default")],2):_vm._e(),(_vm.preload)?_c('img',{staticClass:"btn__preloader",attrs:{"src":require("@/assets/img/preloader.svg"),"alt":""}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }